const getters = {
    userId: state => state.user.id,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    nickname: state => state.user.nickname,
    classIds: state => state.user.classIds,
    courseIds: state => state.user.courseIds,
    examPaperIds: state => state.user.examPaperIds,
}
export default getters
